import SectionMessage from "@atlaskit/section-message";
import { compose, graphql, PageLayout, withGraphqlErrorFlags, withLoadingSpinner, withShowFlag, Permission, } from "@atlassiansox/microscopekit";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import React, { useState, useEffect } from "react";
import CreateLuigiPrompt from "../components/logging/CreateLuigiPrompt";
import ObservabilityForm from "../components/logging/LoggingForm";
import serviceQuery from "../graphql/service.query.graphql";
import setupSentry from "../utils/sentry";
var LoggingPage = function (_a) {
    var data = _a.data, id = _a.id, showFlag = _a.showFlag;
    var _b = useState(null), loggingID = _b[0], setLoggingID = _b[1];
    var _c = useState(false), isEditable = _c[0], setIsEditable = _c[1];
    useEffect(function () {
        // Luigi API does not allow the sentry-trace header via CORS. So we only enable sentry in production
        if (process.env.NODE_ENV === "production") {
            setupSentry();
        }
        if (data.service) {
            var editable = [Permission.Admin, Permission.Write].includes(data.service.currentUserPermission);
            setLoggingID(data.service.metadata.loggingID || "");
            setIsEditable(editable);
        }
    }, [data]);
    if (loggingID && data.service) {
        return (React.createElement(ObservabilityForm, { id: id, loggingId: loggingID, microscopePermission: data.service.currentUserPermission, environments: data.listEnvironments }));
    }
    if (data.service && isEditable) {
        return (React.createElement(PageLayout, { title: "Observability" },
            React.createElement(CreateLuigiPrompt, { serviceName: id, platform: data.service.metadata.platform, 
                // Assuming these are the same thing
                businessUnit: data.service.metadata.businessUnit, owner: data.service.metadata.owner.username, 
                // id is username in the case of a User.
                admins: data.service.metadata.admins.map(function (admin) { return admin.id; }), showFlag: showFlag, setHasLoggingID: setLoggingID })));
    }
    return (React.createElement(PageLayout, { title: "Observability" },
        React.createElement(SectionMessage, { appearance: "information", title: "No Logging ID found" },
            React.createElement("p", null, "This service does not currently have any logging information."))));
};
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export default compose(graphql(serviceQuery, {}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler)(LoggingPage);
